(() => {
  // src/alpine.js
  document.addEventListener("alpine:init", () => {
  });
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-marquee-track]").forEach((track) => {
      const original = track.querySelector("[data-marquee-content]");
      if (!original) return;
      const speed = parseFloat(getComputedStyle(track).getPropertyValue("--marquee-speed")) || 20;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      const contentWidth = original.offsetWidth + gap;
      const copies = Math.ceil(window.innerWidth / contentWidth) + 1;
      for (let i = 2; i <= copies; i++) {
        track.appendChild(original.cloneNode(true));
      }
      track.style.willChange = "transform";
      track.animate(
        [{ transform: "translateX(0)" }, { transform: `translateX(-${contentWidth}px)` }],
        { duration: speed * 1e3, iterations: Infinity, easing: "linear" }
      );
    });
  });
})();
